import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  pdf: null,
}

const getters = {
  pdf(airlineUser) {
    let url = `/UserGuideDownload?type=`
    url += airlineUser ? `FULL` : `ACMF`
    return axios.get(url, {
      responseType: 'blob',
    })
  },
  logicBuilderGuide(alertType) {
    if (alertType)
      return axios.get(`/UserGuideDownload/logicbuilder/${alertType}`, {
        responseType: 'blob',
      })
    else console.error('AlertType not defined', alertType)
  },
}

export default class BlobTransferService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
